export const adaptAlimentacionEnteral = ({ alimentacionEnteralRIByDatosGeneralesId }) => {

    return {
        programaAE1: {
            idAlimentacionEnteralRI: alimentacionEnteralRIByDatosGeneralesId?.idAlimentacionEnteralRI,
            proteinasTotales: alimentacionEnteralRIByDatosGeneralesId?.proteinasTotales,
            caloriasTotales: alimentacionEnteralRIByDatosGeneralesId?.caloriasTotales,
            idComboRIValorTipoAccesoAE: alimentacionEnteralRIByDatosGeneralesId?.idComboRIValorTipoAccesoAE,
            cambioSNGdomicilio: alimentacionEnteralRIByDatosGeneralesId?.cambioSNGdomicilio,
            justificacionNoCambioSNG: alimentacionEnteralRIByDatosGeneralesId?.justificacionNoCambioSNG,
            accesoBuenEstado: alimentacionEnteralRIByDatosGeneralesId?.accesoBuenEstado,
            justificarMalEstado: alimentacionEnteralRIByDatosGeneralesId?.justificarMalEstado,
            idComboRIValorKarnofsky: alimentacionEnteralRIByDatosGeneralesId?.idComboRIValorKarnofsky,
        },
        programaAE2: {
            idAlimentacionEnteralRI: alimentacionEnteralRIByDatosGeneralesId?.idAlimentacionEnteralRI,
            idComboRIValorModoInfusionAE: alimentacionEnteralRIByDatosGeneralesId?.idComboRIValorModoInfusionAE,
            llevaBomba: !!alimentacionEnteralRIByDatosGeneralesId?.llevaBomba
        },
    }
}